import React, { FC, useState } from "react";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { SxProps, ListItemButton, ListItemText, Collapse, List, Theme, Typography } from "@mui/material";
import { IGroupedDevices } from "common/store/DeviceStore";
import BladeDevice from "./BladeDevice";

interface IProps {
  level: number;
  plusMinusIconLevel: number;
  blades: IGroupedDevices[];
}

const BladeItem: FC<IProps> = (props) => {
  const { level, plusMinusIconLevel, blades } = props;
  const [open, setOpen] = useState<Record<string, boolean>>({});

  const handleClick = (blade: IGroupedDevices, key: number) => {
    if (blade.children?.length > 0) {
      setOpen((prevOpen) => ({
        ...prevOpen,
        [key]: !prevOpen[key],
      }));
    }
  };

  const GetSxProps = (blade: IGroupedDevices): SxProps<Theme> | null => {
    const pr = blade.children?.length > 0 ? "0px" : "16px";
    if (level === 0) {
      return {
        pl: `${level * 8}px`,
        pr: pr,
        pt: "2px",
        pb: "2px",
        //   backgroundColor: "secondary.main",
        //   color: "secondary.contrastText",
        ":hover": { backgroundColor: "initial" },
      };
    } else
      return {
        pl: `${level * 8}px`,
        pr: pr,
        pt: "0px",
        pb: "0px",
        "&:hover": {
          backgroundColor: "initial",
          color: "primary.main",
        },
      };
  };

  const GetExpandIcon = (blade: IGroupedDevices, key: number): JSX.Element | null => {
    if (blade.children?.length > 0) {
      if (level === plusMinusIconLevel) {
        return open[key] === true ? <RemoveIcon /> : <AddIcon />;
      } else {
        return open[key] === true ? <ExpandLess /> : <ExpandMore />;
      }
    }
    return null;
  };

  return (
    <>
      {blades.map((blade, key) => {
        return (
          <React.Fragment key={level * 10 + key}>
            <ListItemButton sx={GetSxProps(blade)} disableGutters onClick={() => handleClick(blade, key)}>
              {blade.children?.length === 0 ? (
                <BladeDevice blade={blade} />
              ) : (
                <ListItemText
                  primary={
                    <Typography variant={level === 0 ? "topLevelBlade" : "innerLevelBlade"}>{blade.name}</Typography>
                  }
                />
              )}
              {GetExpandIcon(blade, key)}
            </ListItemButton>
            {blade.children?.length > 0 && (
              <Collapse in={open[key]} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <BladeItem level={level + 1} plusMinusIconLevel={plusMinusIconLevel} blades={blade.children} />
                </List>
              </Collapse>
            )}
          </React.Fragment>
        );
      })}
    </>
  );
};

export default BladeItem;
